"use client";

import type {
  BrandPageFragment,
  CampaignFragment,
  CategoryPageFragment,
  DesignerPageFragment,
} from "@server/gql/graphql";
import type { Dispatch, SetStateAction } from "react";
import { createContext } from "react";
import type { Dictionary, Image, Product, Variant } from "types";

import { getDefaultMarket } from "@/config/market-configurations";
import type { MarketConfiguration } from "@/config/markets/const";

export type ProductCardContextProps = {
  marketConfig: MarketConfiguration;
  locale?: string;
  product?: Product | Variant;
  pageData?:
    | CampaignFragment
    | BrandPageFragment
    | CategoryPageFragment
    | DesignerPageFragment
    | null;
  globalDictionary?: Dictionary;
  hideHoverImage?: boolean;
  hideStock?: boolean;
  isDense?: boolean;
  primaryImage?: Image;
  hoverImage?: Image;
  hoverImageHasLoaded?: boolean;
  setHoverImageHasLoaded?: Dispatch<SetStateAction<boolean>>;
  onRemove?: () => void;
  isEager?: boolean;
};

export const ProductCardContext = createContext<ProductCardContextProps>({
  globalDictionary: {},
  marketConfig: getDefaultMarket(),
});
